import { IDataTh, ThCoreIndex } from "src/Pages/components";

export const THeadOperadora = () => {
  const dataTh: IDataTh[] = [
    {
      title: "Ações",
      width: "40px",
      align: "left",
    },
    {
      title: "Operadoras",
      align: "left",
      width: "90%",
    },
    {
      title: "Ativo",
      align: "center",
      width: "100px",
    },
  ];

  return <ThCoreIndex dataTh={dataTh} />;
};
